import { GET_CAREGIVER } from "../actions/types";

const careGiver = (state = [], action) => {
    switch (action.type) {
        case GET_CAREGIVER:
            return action.payload;
        default:
            return state;
    }
};

export default careGiver;
